export default __webpack_public_path__ + "static/media/people.b207c6ca.png";